module.exports = __webpack_public_path__ + "static/media/Pain Management While on Buprenorphine for Opioid Use Disorder 08-22_FINAL.0419a26c.jpg";